import React, { Component } from 'react';

import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import ContentHeader from 'components/ContentHeader';
import Button from 'components/Button';
import Footer from 'components/AppFooter/AppFooter'

export default class Admin extends Component {

	render () {
		return (
			<ReactCSSTransitionGroup
				transitionName="main-content"
				transitionAppear={true}
	      transitionAppearTimeout={1500}
				transitionEnterTimeout={1500}
				transitionLeaveTimeout={1500}
				className="main-transition-wrap"
			>
			<div className="main-content-area" key="admin">
				<ContentHeader
					title="Admin"
				/>
				<div className="page-content">
					<div className="container">

					</div>
					<Footer/>
				</div>
			</div>
			</ReactCSSTransitionGroup>
		);
	}
}



// WEBPACK FOOTER //
// ./js/containers/Admin/Admin.js